import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import Product from "./Pages/Product";
import Education from "./Pages/Education";
import FAQ from "./Pages/FAQ";
import Blog from "./Pages/Blog";
import BlogCardDetailPage from "./Pages/BlogCardDetailPage";
import ContactUs from "./Pages/ContactUs";
import AboutsUs from "./Pages/AboutsUs";
import WhyUs from "./Pages/WhyUs";
import ProductJson from "./Components/Data/Product";
import Registration from "./Components/Registration/Registration";
import Login from "./Components/Login/Login";
import Profile from "./Components/Profile/Profile";
import MobileProfile from "./Components/MobileProfile/Profile";
import OrderDetails from "./Components/Profile/order/OrderDetails";
import OrderFilter from "./Pages/OrderFilter";
import { AddToCart } from "./Components/CartSammary/AddToCart";
import AdminHome from "./Components/AdminPanel/AdminHome";
import Orders from "./Components/MobileProfile/Orders";
import Success from "./Components/PaymentSucessFailed/Success";
import Failed from "./Components/PaymentSucessFailed/Failed";
import Gallery from "./Pages/Gallery";
import Exibition from "./Pages/Exibition";
import BranchPage from "./Pages/BranchPage";
import FooterCountryData from "./Components/Data/FooterCountryData";
import TermsCondition from "./Pages/TermsCondition";
import Dashboard from "./Components/AdminPanel/Dashboard";
import ForgotPassword from "./Pages/ForgotPassword";
import { useEffect, useState } from "react";
import { post } from "./apiService";
import AccessDenied from "./Pages/AccessDenied";
import GoogleTranslate from "./Components/GoogleTranslate";

function App() {
  const [IsAtive, setIsActive] = useState();

  useEffect(() => {
    const fetchIp = async () => {
      try {
        // First fetch the IP address using ipify

        const geoResponse = await fetch(`https://ipapi.co/json/`);
        const geoData = await geoResponse.json();
        console.log(geoData)
        if (geoData) {
          const formData = new FormData();
          formData.append("ip_address", geoData.ip);
          formData.append("country", geoData.country_name);
          formData.append("city", geoData.city);
          formData.append("region", geoData.region);
          formData.append("postal", geoData.postal);
          formData.append("reason", "");
          formData.append("action", "add");

          // Send the data to your backend API
          const resp = await post("/block_ipaddress.php", formData);
          if (resp) {
            setIsActive(resp?.message?.data); // Set the response data to update state
          }
        }
      } catch (error) {
        console.error("Error fetching IP address or geolocation data:", error);
      }
    };

    fetchIp();
  }, []);

  return IsAtive?.status != 0 ? (
    <>
       <GoogleTranslate />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          {ProductJson?.map((v) => (
            <Route path={v.slug} element={<Product />} />
          ))}
          {FooterCountryData?.map((v) => (
            <Route path={v.slug} element={<BranchPage />} />
          ))}
          <Route path="/natural-diamonds" element={<Education />} />
          <Route path="/calibrated-diamonds" element={<FAQ />} />
          <Route path="/best-diamond-supplier" element={<Blog />} />
          <Route path="/best-diamonds-collection" element={<AboutsUs />} />
          <Route path="/fancy-color-diamonds" element={<Gallery />} />
          <Route path="/best-diamond-exhibition" element={<Exibition />} />
          <Route path="/view/:slug" element={<BlogCardDetailPage />} />
          <Route path="/diamond-wholesaler" element={<WhyUs />} />
          <Route path="/best-diamond-dealer" element={<ContactUs />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profiles" element={<MobileProfile />} />
          <Route path="/login" element={<Login />} />
          <Route path="/order-details" element={<OrderDetails />} />
          <Route path="/add-to-cart" element={<AddToCart />} />
          <Route path="/search" element={<OrderFilter />} />
          <Route path="/profiles/orders" element={<Orders />} />
          <Route path="/admin-panel" element={<AdminHome />} />
          <Route path="/payment-sucess/:orderId" element={<Success />} />
          <Route path="/payment-failed/:orderId" element={<Failed />} />
          <Route path="/terms-&-conditions" element={<TermsCondition />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Routes>
      </BrowserRouter>
    </>
  ) : (
    <AccessDenied />
  );
}

export default App;
